<form [formGroup]="form">
  <div *ngIf="isUpdate">
    <div *ngIf="isArchived">
      <span
        class="d-flex text-wrap align-items-baseline"
        [ngClass]="'alert'"
        style="background-color: #FFE899; color: #E56B00; border-radius: 4.45px;"
      >
        <i class="icofont icofont-info-circle"></i>
        <div class="lh-base">
          <span>
            {{ "warningMessages.archivedDoesNotShowForAdvertisers1" | translate }}
            <b>{{ "warningMessages.archivedDoesNotShowForAdvertisers2" | translate }}</b>,
            {{ "warningMessages.archivedDoesNotShowForAdvertisers3" | translate }}
            <b>{{ "warningMessages.archivedDoesNotShowForAdvertisers4" | translate }}</b>,
            {{ "warningMessages.archivedDoesNotShowForAdvertisers5" | translate }}
          </span>
        </div>
      </span>
    </div>
    <div class="media m-t-10">
      <label class="label"
        >{{ "admin.locations.repository.adminDisplay" | translate }} *</label
      >
      <div class="media-body text-end icon-state">
        <label class="switch icon-state">
          <input
            formControlName="showingAdmin"
            class="mode"
            type="checkbox"
            [checked]="showingAdmin"
          /><span class="switch-state"> </span>
        </label>
      </div>
    </div>
    <div class="media">
      <label class="label"
        >{{
          "admin.locations.repository.advertiserDisplay" | translate
        }}
        *</label
      >
      <div class="media-body text-end icon-state">
        <label class="switch icon-state">
          <input
            formControlName="showingAdvertiser"
            class="mode"
            type="checkbox"
            [checked]="showingAdvertiser"
          /><span class="switch-state"> </span>
        </label>
      </div>
    </div>
    <div class="form-group">
      <label class="label"
        >{{ "addLP.partnerStatus.status" | translate }} *</label
      >
      <div class="input-group">
        <select class="form-select form-control" formControlName="status">
          <option [ngValue]="null" disabled selected>
            {{ "addLP.partnerStatus.status" | translate }}
          </option>
          <option
            *ngFor="let item of locationPartnerStatus"
            [ngValue]="item.id"
          >
            {{ item.value | translate }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <label class="label"
        >{{ "admin.locations.repository.expenses" | translate }} *</label
      >
      <div class="input-group">
        <input
          formControlName="expenses"
          class="form-control"
          type="text"
          required=""
          [placeholder]="'addLP.partnerStatus.placeholderExpenses' | translate"
          [ngClass]="{
            'is-invalid':
              !form.get('expenses')?.valid && form.get('expenses')?.touched
          }"
        />
        <div
          class="invalid-feedback"
          *ngIf="!form.get('expenses')?.valid && form.get('expenses')?.touched"
        >
          {{ "validation.expenses" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label">{{ "addLP.partnerStatus.title" | translate }} *</label>
    <div class="input-group">
      <select class="form-select form-control" formControlName="partnerStatus">
        <option [ngValue]="null" disabled selected>
          {{ "addLP.partnerStatus.selectPartner" | translate }}
        </option>
        <option *ngFor="let item of partnerStatus" [ngValue]="item.id">
          {{ item.value | translate }}
        </option>
      </select>
    </div>
  </div>
  <div *ngIf="getPartnerStatus == partnerStatusEnum.REVENUE_SHARING">
    <div class="form-group">
      <label class="label"
        >{{ "addLP.partnerStatus.PilotPhase" | translate }} *</label
      >
      <input
        formControlName="date"
        class="form-control"
        type="text"
        name="daterange"
        [placeholder]="'placehorderPickDate' | translate"
        [selectMode]="'range'"
        [owlDateTimeTrigger]="ranges"
        [owlDateTime]="ranges"
      />
      <owl-date-time [pickerType]="'calendar'" #ranges></owl-date-time>
    </div>
    <div *ngIf="isUpdate">
      <div class="form-group">
        <label class="label"
          >{{ "admin.locations.repository.price" | translate }} *</label
        >
        <div class="input-group">
          <input
            formControlName="price"
            class="form-control"
            type="text"
            required=""
            [placeholder]="'admin.locations.repository.price' | translate"
            [ngClass]="{
              'is-invalid':
                !form.get('price')?.valid && form.get('price')?.touched
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="!form.get('price')?.valid && form.get('price')?.touched"
          >
            {{ "validation.price" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="form-group"
    *ngIf="
      isUpdate ||
      getPartnerStatus == partnerStatusEnum.INTERNET_PROVIDER_PAYMENT
    "
  >
    <label class="label"
      >{{ "admin.locations.repository.priceFrequency" | translate }} *</label
    >
    <select class="form-select form-control" formControlName="paymentFrequency">
      <option [ngValue]="null" disabled selected>
        {{ "addLP.partnerStatus.selectPaymentFrequency" | translate }}
      </option>
      <option *ngFor="let item of paymentFrequency" [value]="item.id">
        {{ item.value | translate }}
      </option>
    </select>
  </div>
</form>
